"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _table = _interopRequireDefault(require("../../../../core/table"));
var _button = _interopRequireDefault(require("../../../../core/button"));
var _input = _interopRequireDefault(require("../../../../core/input"));
var _editableMultiSelect = _interopRequireDefault(require("../../../../core/editable-multi-select"));
var _editableField = _interopRequireDefault(require("../../../../core/editable-field"));
var _selectCode = _interopRequireDefault(require("../../../../core/select-code"));
var _deleteButton = _interopRequireDefault(require("../../../../core/delete-button"));
var _eligibilities = _interopRequireDefault(require("./eligibilities"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("th", null);
var _ref2 = /*#__PURE__*/_react.default.createElement("th", null, " Race");
var _ref3 = /*#__PURE__*/_react.default.createElement("th", null, " Move Day");
var _ref4 = /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Entry Limit");
var _ref5 = /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Reserved Entry");
var _ref6 = /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Completed");
var _ref7 = /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Waiting List");
var _ref8 = /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Cancelled");
var _ref9 = /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Full");
var _ref10 = /*#__PURE__*/_react.default.createElement("th", null, "Specials");
var _ref11 = /*#__PURE__*/_react.default.createElement("th", null);
var _ref12 = /*#__PURE__*/_react.default.createElement("td", null);
class RacesTable extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      showEligibilities: {}
    });
    _defineProperty(this, "_getAllEligibilitiesShown", () => {
      return this.props.races.every(race => this.state.showEligibilities[race.id]);
    });
    _defineProperty(this, "_toggleShowAllEligibilities", () => {
      const newShowEligibilities = {};
      const showAllEligibilities = !this._getAllEligibilitiesShown();
      this.props.races.forEach(race => {
        newShowEligibilities[race.id] = showAllEligibilities;
      });
      this.setState({
        showEligibilities: newShowEligibilities
      });
    });
    _defineProperty(this, "_toggleShowEligibilities", raceID => {
      this.setState({
        showEligibilities: {
          ...this.state.showEligibilities,
          [raceID]: !this.state.showEligibilities[raceID]
        }
      });
    });
    _defineProperty(this, "_toggleSpecialsSelection", (raceID, refCode, value) => {
      if (value) {
        this.props.onCreateRaceSpecial(raceID, refCode);
      } else {
        this.props.onDeleteRaceSpecial(raceID, refCode);
      }
    });
    _defineProperty(this, "_onChange", (raceID, field, value) => {
      this.props.onUpdate(raceID, field, value);
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._toggleShowAllEligibilities
    }, this._getAllEligibilitiesShown() ? 'Hide All' : 'Show All'), /*#__PURE__*/_react.default.createElement(_table.default, null, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, _ref, _ref2, !this.props.userCanModifyCompetitionStructure ? null : _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11)), /*#__PURE__*/_react.default.createElement("tbody", null, this.props.races.map(race => [/*#__PURE__*/_react.default.createElement("tr", {
      key: race.id
    }, /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      size: "sm",
      onClick: this._toggleShowEligibilities.bind(this, race.id),
      block: true
    }, this.state.showEligibilities[race.id] ? 'Hide Eligibilities' : 'Who Can Enter?')), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: this.props.userIsSystemAdmin,
      type: "text",
      name: "raceName",
      value: race.raceName,
      maxLength: 20,
      onChange: this._onChange.bind(this, race.id, 'raceName')
    })), !this.props.userCanModifyCompetitionStructure ? null : /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_selectCode.default, {
      lookup: "CompetitionDays",
      competitionID: this.props.competitionID,
      value: race.competitionDayID,
      name: "competitionDayID",
      onChange: this._onChange.bind(this, race.id, 'competitionDayID'),
      clearable: false
    })), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: true,
      className: "text-xs-right",
      type: "Integer",
      name: "raceEntryLimit",
      value: race.raceEntryLimit,
      maxLength: 3,
      onChange: this._onChange.bind(this, race.id, 'raceEntryLimit')
    })), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: true,
      className: "text-xs-right",
      type: "Integer",
      name: "raceReservedEntry",
      value: race.raceReservedEntry,
      maxLength: 3,
      onChange: this._onChange.bind(this, race.id, 'raceReservedEntry'),
      required: true
    })), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right read-only"
    }, race.numberOfCompletedEntries), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right read-only"
    }, race.numberOnWaitingList), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      "data-test-id": (race.isCancelled ? 're-instate-checkbox-' : 'cancel-checkbox-') + race.id,
      type: "Checkbox",
      name: "isCancelled",
      checked: race.isCancelled,
      onChange: this._onChange.bind(this, race.id, 'isCancelled')
    })), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      "data-test-id": (race.isFull ? 'uncheck-full-' : 'check-full-') + race.id,
      type: "Checkbox",
      name: "isFull",
      checked: race.isFull,
      onChange: this._onChange.bind(this, race.id, 'isFull')
    })), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_editableMultiSelect.default, {
      enabled: this.props.userIsSystemAdmin,
      lookup: "RefCodes",
      codeType: "calendarspecial",
      name: "specialRef",
      colSize: 6,
      selectedCodes: race.specialRefs,
      onChange: this._toggleSpecialsSelection.bind(this, race.id)
    })), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-center"
    }, !this.props.userCanModifyCompetitionStructure || race.hasEntries ? null : /*#__PURE__*/_react.default.createElement(_deleteButton.default, {
      onClick: this.props.onDelete.bind(this, race.id),
      size: "sm"
    }))), !this.state.showEligibilities[race.id] ? null : /*#__PURE__*/_react.default.createElement("tr", {
      key: race.id + 'Eligibilities'
    }, _ref12, /*#__PURE__*/_react.default.createElement("td", {
      colSpan: 6
    }, /*#__PURE__*/_react.default.createElement(_eligibilities.default, {
      userCanModifyCompetitionStructure: this.props.userCanModifyCompetitionStructure,
      userIsSystemAdmin: this.props.userIsSystemAdmin,
      eligibilities: race.eligibilities,
      raceID: race.id
    })))]))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = (0, _reactBicycle.connect)(RacesTable, undefined, (client, props) => ({
  onUpdate(id, field, value) {
    return client.update('Race.set', {
      id,
      field,
      value
    });
  },
  onDelete(raceID) {
    return client.update('Race.delete', {
      raceID
    });
  },
  onCreateRaceSpecial(raceID, specialRef) {
    return client.update('Race.createRaceSpecial', {
      raceID,
      specialRef
    });
  },
  onDeleteRaceSpecial(raceID, specialRef) {
    return client.update('Race.deleteRaceSpecial', {
      raceID,
      specialRef
    });
  }
}));